import { useState, useEffect, useMemo } from "react";

const ManagerTable = ({ groupedOrders, initialLeads, planCompleted }) => {
    const [leadInput, setLeadInput] = useState({});

    useEffect(() => {
        const savedLeads = localStorage.getItem("managerLeads");
        if (savedLeads) {
            try {
                setLeadInput(JSON.parse(savedLeads) || {}); // Гарантируем объект
            } catch (error) {
                console.error("Помилка парсингу JSON:", error);
                setLeadInput(initialLeads || {}); // Гарантируем объект
            }
        } else {
            setLeadInput(initialLeads || {}); // Гарантируем объект
        }
    }, []);


    useEffect(() => {
        localStorage.setItem("managerLeads", JSON.stringify(leadInput));
    }, [leadInput]);

    const handleChangeLeads = (managerId, value) => {
        setLeadInput(prev => ({
            ...prev,
            [managerId]: Number(value) || 0
        }));
    };

    const updatedOrders = useMemo(() => {
        return groupedOrders.map(manager => {
            const leadsCount = leadInput[manager.managerId] || 0;
            let conversionRate = leadsCount > 0
                ? Number(((manager.salesCount / leadsCount) * 100).toFixed(2))
                : 0;

            // Проверяем salaryPercentage, если его нет, ставим 5% по умолчанию
            let salaryPercentage = manager.salaryPercentage ?? 0.03;
            if (planCompleted && [5, 6, 11].includes(manager.managerId)) {
                salaryPercentage = 0.04; // Фиксируем 4% для нужных менеджеров
            }

            const salary = Math.floor(manager.turnover * salaryPercentage);

            return {
                ...manager,
                conversionRate,
                salary
            };
        });
    }, [groupedOrders, leadInput, planCompleted]);

    return (
        <section className="section-table">
            <div className="holder-table">
                <div className="flex justify-center p-6">
                    <div className="w-full max-w-6xl">
                        <table className="table table-orders table-bordered table-striped">
                            <thead className="stiky header-table">
                            <tr>
                                <th className="border px-8 py-4 text-white bg-gray-200 text-center">Параметры</th>
                                {updatedOrders.map(({ managerId, manager }) => (
                                    <th key={managerId} className="border px-8 py-4 text-white bg-gray-200 text-center">{manager}</th>
                                ))}
                            </tr>
                            </thead>
                            <tbody>
                            {[
                                { label: "Зарплатня", key: "salary", suffix: " грн." },
                                { label: "Товарообіг", key: "turnover", suffix: " грн." },
                                { label: "Количество продаж", key: "salesCount", suffix: " шт." },
                                { label: "Средний чек", key: "averageCheck", suffix: " грн." },
                                { label: "Количество допродаж", key: "upsellCount", suffix: " шт." },
                                { label: "Неуспешные заказы", key: "failedOrdersCount", suffix: " шт." },
                                { label: "Процент возвратов", key: "returnRate", suffix: "%" },
                                { label: "Конверсия в продажу", key: "conversionRate", suffix: "%" }
                            ].map(({ label, key, suffix }) => (
                                <tr key={key} className="hover:bg-gray-100 transition duration-200">
                                    <td className="border px-8 py-4 font-semibold text-gray-800 bg-gray-50 text-center">{label}</td>
                                    {updatedOrders.map(manager => (
                                        <td key={manager.managerId} className="border px-8 py-4 text-gray-700 text-center">{manager[key]}{suffix}</td>
                                    ))}
                                </tr>
                            ))}

                            <tr className="hover:bg-gray-100 transition duration-200">
                                <td className="border px-8 py-4 font-semibold text-gray-800 bg-gray-50 text-center">Количество лидов</td>
                                {updatedOrders.map(({ managerId }) => (
                                    <td key={managerId} className="btn-holder border px-8 text-center">
                                        <input
                                            type="number"
                                            value={leadInput[managerId] || ""}
                                            onChange={(e) => handleChangeLeads(managerId, e.target.value)}
                                            className="w-full h-full text-center bg-transparent border-0 focus:border-gray-300 transition duration-200"
                                            placeholder="0"
                                        />
                                    </td>
                                ))}
                            </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default ManagerTable;
